// Public API for the shared FIM evidence panels. These re-declarations (rather
// than `export … from`) keep the module free of the `no-barrel-files` re-export
// pattern; see `features/equipment/index.ts` for the same approach.
import type { NormalizedBBox as _NormalizedBBox } from 'features/knowledgeDocumentViewer/types/ocrViewer'

import { EvidenceProcessDataPanel as _EvidenceProcessDataPanel } from './ProcessDataPanel'
import {
  confidenceBandColor as _confidenceBandColor,
  ConfidenceMeter as _ConfidenceMeter,
  CorroborationGlyph as _CorroborationGlyph,
  fmtConfidence as _fmtConfidence,
  prettify as _prettify,
} from './SubjectGlyphs'
import {
  type EvidenceDocRelation as _EvidenceDocRelation,
  type EvidenceLinkedDocument as _EvidenceLinkedDocument,
  isPidDocument as _isPidDocument,
  parseBboxStrings as _parseBboxStrings,
} from './types'

export const EvidenceProcessDataPanel = _EvidenceProcessDataPanel
export const isPidDocument = _isPidDocument
export const parseBboxStrings = _parseBboxStrings

export const CorroborationGlyph = _CorroborationGlyph
export const ConfidenceMeter = _ConfidenceMeter
export const confidenceBandColor = _confidenceBandColor
export const fmtConfidence = _fmtConfidence
export const prettify = _prettify

export type EvidenceDocRelation = _EvidenceDocRelation
export type EvidenceLinkedDocument = _EvidenceLinkedDocument
export type NormalizedBBox = _NormalizedBBox
